type ListenerFn = Parameters<NetDSL["listener"]>[0]
type ListenerConfig = Parameters<NetDSL["listener"]>[1]
type Params = Parameters<ListenerFn>
let listener: ListenerFn | undefined = undefined
let listenerTimer: NodeJS.Timeout | null = null
const statusMap: { [key: string]: "none" | "strong" | "weak" } = {
  "4g": "strong",
  "3g": "weak",
  "2g": "weak",
}

function isOnline() {
  if (!window || !window.navigator) {
    throw new Error("window.navigator is not defined")
  }
  return window.navigator.onLine ?? true
}

export const netListener = {
  init(fn?: ListenerFn, config?: ListenerConfig) {
    listener = fn
    if (config) {
      netListener.emit(config)
    }
  },
  emit(config: ListenerConfig) {
    if (listener == null) return
    if (listenerTimer) {
      clearTimeout(listenerTimer)
    }
    listenerTimer = setTimeout(() => {
      const { connection } = window.navigator as any
      const effectiveType = connection?.effectiveType
      const _isOnline = isOnline()
      listener({
        online: _isOnline,
        status: !_isOnline ? "none" : statusMap[effectiveType],
      })
      listenerTimer = null
      if (config) {
        netListener.emit(config)
      }
    }, config.rateTime)
  },
  off() {
    if (listenerTimer) {
      clearTimeout(listenerTimer)
      listenerTimer = null
    }
    listener = undefined
  },
}
